export enum ChannelIds {
  Export = 'export',
  Print = 'print',
  LazyLoadUpdate = 'lazyLoadUpdate',
}
